export default __webpack_public_path__ + "static/media/clube-img2.988c5216.jpg";